var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardPanel',{attrs:{"title":"报修类型分布","meta":"单位：单"}},[_c('div',{staticClass:"repair-type"},[_c('div',{ref:"bars",staticClass:"repair-type__bars"}),_c('div',{staticClass:"repair-type__trend"},[_c('div',[_vm._v("近7日趋势（单）")]),_c('div',{ref:"trend",staticClass:"repair-type__line"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }